import { Drawer } from "@material-ui/core";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuClose = () => setMobileMenuOpen(false);

  const handleMobileClick = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    const path = location.pathname.split("/").filter(Boolean).pop() || "";
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  return (
    <header className="headerWrapper">
      <nav className="container-fluid container-md headerWrapper__navigation">
        <div>
          <div className="headerWrapper__logo--container">
            <Link to="/">
              <img
                src="/logo.png"
                alt="Atheriam - AI Gaming Blockchain"
              />
            </Link>
          </div>
        </div>

        <ul className="headerLinks">
          <li>
            <Link to="/" className={`${isActive("")}`}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/blockchain" className={`${isActive("blockchain")}`}>
              Blockchain
            </Link>
          </li>
          <li>
            <Link to="/gaming" className={`${isActive("gaming")}`}>
              Gaming
            </Link>
          </li>
          <li>
            <Link to="/tokenomics" className={`${isActive("tokenomics")}`}>
              Tokenomics
            </Link>
          </li>
          <li>
            <Link to="/ico" className={`${isActive("ico")}`}>
              ICO
            </Link>
          </li>
        </ul>

        <div>
          <Link to="/ico" className="header-btn">
            Get Started
            <span className="header-btn-arr">
              <i className="fa-solid fa-arrow-right"></i>
            </span>
          </Link>
        </div>

        <div className="headerWrapper__navigation--hamburger">
          <div className="landing-ham" onClick={handleMobileClick}>
            {!mobileMenuOpen ? (
              <i className="fa-solid fa-bars"></i>
            ) : (
              <i className="fa-solid fa-xmark"></i>
            )}
          </div>
        </div>

        <Drawer
          anchor="left"
          open={mobileMenuOpen}
          onClose={handleMobileMenuClose}
          className="primary__landing-drawer-menu"
        >
          <div className="mobileMenu">
            <div className="logo_new_sectio mobileMenu-logo">
              <Link to="/" onClick={handleMobileMenuClose}>
                <img
                  src="/logo.png"
                  alt="Atheriam - AI Gaming Blockchain"
                  className="header-mob-logo"
                />
              </Link>
            </div>

            <div className="primary__drawer-btn mt-4">
              <li onClick={handleMobileMenuClose}>
                <Link to="/" className="header-mob-links">
                  Home
                </Link>
              </li>
              <li onClick={handleMobileMenuClose}>
                <Link to="/blockchain" className="header-mob-links">
                  Blockchain
                </Link>
              </li>
              <li onClick={handleMobileMenuClose}>
                <Link to="/gaming" className="header-mob-links">
                  Gaming
                </Link>
              </li>
              <li onClick={handleMobileMenuClose}>
                <Link to="/tokenomics" className="header-mob-links">
                  Tokenomics
                </Link>
              </li>
              <li onClick={handleMobileMenuClose}>
                <Link to="/ico" className="header-mob-links">
                  ICO
                </Link>
              </li>
              <li onClick={handleMobileMenuClose}>
                <Link to="/ico" className="header-btn sidebar-btn">
                  Get Started
                  <span className="header-btn-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </Link>
              </li>
            </div>
          </div>
        </Drawer>
      </nav>
    </header>
  );
};

export default Header;
